// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LB3Jm","col":"styles_col__2JCny"};